import { render, staticRenderFns } from "./my-form-item-group.vue?vue&type=template&id=7ec9d107&"
import script from "./my-form-item-group.vue?vue&type=script&lang=js&"
export * from "./my-form-item-group.vue?vue&type=script&lang=js&"
import style0 from "./my-form-item-group.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports